export interface Lang {
  id: string;
  img: string;
  label: string;
}

export const lang: Lang[] = [
  {
    id: 'it',
    img: 'https://flagcdn.com/it.svg',
    label: 'lang.it',
  },
  {
    id: 'en',
    img: 'https://flagcdn.com/gb.svg',
    label: 'lang.en',
  },
];
